
const paymentTermsSelectorElementNonItemized = document.getElementById('test-payment-terms-selector');
const formDataNonItemized = document.getElementById('form-data');
const addPaymentTermsNonItemized = document.getElementById('add-payment-terms');

paymentTermsSelectorElementNonItemized.addEventListener('outputPaymentTermForm', function(event) {
  if ((event as any).detail) {
    formDataNonItemized.innerText = JSON.stringify((event as any).detail);
  }
});

paymentTermsSelectorElementNonItemized.addEventListener('openPaymentTermsModal', function(event) {
  if ((event as any).detail) {
    addPaymentTermsNonItemized.innerText = JSON.stringify((event as any).detail);
  }
});
